export default "__VITE_ASSET__BLMOuLej__"